export const findMappingByTypeResponseDtoType = {
  PRODUCT: "PRODUCT",
  MATERIAL: "MATERIAL",
  STANDARD: "STANDARD",
} as const
export type FindMappingByTypeResponseDtoType =
  (typeof findMappingByTypeResponseDtoType)[keyof typeof findMappingByTypeResponseDtoType]
export type FindMappingByTypeResponseDto = {
  /**
   * @type string
   */
  id: string
  /**
   * @type number
   */
  typeId: number | null
  /**
   * @type string
   */
  key: string | null
  /**
   * @type string
   */
  alias: string
  /**
   * @type string
   */
  type: FindMappingByTypeResponseDtoType
}
